import React from "react";
class AddAdminModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
    };
  }
  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  addUser = () => {
    const { username, email } = this.state;
    const { addUser } = this.props;
    addUser(username, email);
  };
  render() {
    const { username, email } = this.state;
    return (
      <div
        className="modal fade"
        id="add_admin"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Investor</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-username"
                  name="username"
                  placeholder="First Name"
                  onChange={this.onChangeHandler}
                  value={username}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-email"
                  name="email"
                  placeholder="Email"
                  onChange={this.onChangeHandler}
                  value={email}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.addUser}
              >
                Invite
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddAdminModal;



// WEBPACK FOOTER //
// ./src/components/AddAdminModal/index.js